.root {
    border: none;
}
